import { cloneElement } from "react";

const colors = require("@theme/colors") as Record<string, any>;

export type SidebarItemTemplateProps = {
  label: string;
  icon: JSX.Element;
  onClick: () => void;
  selected: boolean;
  isSectionIncomplete: boolean;
};

export const SidebarItemTemplate = ({
  label,
  icon,
  onClick,
  selected,
  isSectionIncomplete
}: SidebarItemTemplateProps): JSX.Element => {
  const coloredIcon = selected
    ? cloneElement(icon, { color: colors.primary.medium })
    : icon;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${selected ? "bg-primary-lightest" : "bg-transparent"} 
        w-full block px-4 py-3 rounded-md transition ease-in-out delay-0 hover:bg-primary-lightest duration-150`}
    >
      <div className="flex items-center justify-start">
        <div>{coloredIcon}</div>
        <div className="flex flex-row w-full ml-3 justify-between items-center">
          <div
            className={`text-base ${
              selected ? "font-bold text-primary-medium" : "font-normal text-black"
            }`}
          >
            {label}
          </div>
          {isSectionIncomplete && 
            <div className="ml-2 rounded-full w-2 h-2 bg-attention-dark"></div>
          }
        </div>
      </div>
    </button>
  );
};
